
import { Button } from '@imprivata-cloud/components';
import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

export type AccountStatusType = 'locked' | 'disabled';

const errorMessages = {
  locked: 'errors.idp-locked',
  disabled: 'errors.account-disabled'
};

export const AccountLockScreen = ({
  onRetry,
  statusType = 'locked'
}: {
  onRetry: () => void;
  statusType?: AccountStatusType;
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      vertical
      flex={1}
      justify="space-between"
      align="center"
      className="w-100 flex-align-self-stretch"
    >
      <Flex
        vertical
        flex={1}
        justify="center"
        align="center"
        gap={24}
        className="w-100"
      >
        <Flex
          vertical
          align="center"
          justify="center"
          className="w-100"
          style={{ textAlign: 'center' }}
        >
          <Typography.Title level={4}>
            {t('errors.account-locked-title')}
          </Typography.Title>
          <Typography.Text type="secondary">
            {t(errorMessages[statusType])}
          </Typography.Text>
        </Flex>
      </Flex>
      <Flex vertical gap={12} className="w-100">
          <Button
            label={t('actions.again')}
            type="primary"
            block
            onClick={onRetry}
          />
      </Flex>
    </Flex>
  );
};
